import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentCtx = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/content");
      setContent(r.data);
    } catch {
      setContent({});
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentCtx.Provider value={{ content: content || {}, refresh }}>
      {children}
    </ContentCtx.Provider>
  );
}

export const useContent = () => useContext(ContentCtx) || { content: {}, refresh: () => {} };
